import React from 'react';
import Textfield from '@atlaskit/textfield';
import { DisplayMode } from '../../RenderForm';
import { FieldDisabledWrapper, ViewWrapper } from '../common/questionWrappers';
export const ViewNumber = ({
  id,
  value,
  displayMode
}) => {
  if (displayMode === DisplayMode.Edit || displayMode === DisplayMode.Preview || displayMode === DisplayMode.Translate) {
    return /*#__PURE__*/React.createElement(FieldDisabledWrapper, null, /*#__PURE__*/React.createElement(Textfield, {
      id: id,
      value: value,
      isReadOnly: true,
      width: "small",
      label: "number",
      "aria-label": "number field",
      title: "number",
      placeholder: "",
      role: "presentation"
    }));
  }
  return /*#__PURE__*/React.createElement(ViewWrapper, null, value);
};